import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface ComponentType {
  readonly name: string;
  readonly id: string;
  readonly discipline: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified: string;
  readonly abbrv: string;
  readonly assetCategory: number;
  readonly site: number;
  readonly dateCreated: string;
}

export const componentTypeSchema: RxJsonSchema<ComponentType> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
    abbrv: { type: ['string', 'null'] },
    assetCategory: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
  },
};
export type ComponentTypeCollection = RxCollection<ComponentType> | null;
export type ComponentTypeDocument = RxDocument<ComponentType>;

export const componentTypePullQueryBuilder = (document: ComponentType) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query componentTypeFeed($discipline: Int!, $lastRequested: DateTime!) {
      componentTypeFeed(discipline: $discipline, lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
        abbrv
        assetCategory
        site
        dateCreated
      }
    }
  `);

  return {
    query,
    variables: {
      discipline: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export default {};
